<template>
  <div class="dish-showcase">
    <!-- 侧边分类菜单 -->
    <div class="sidebar">
      <div class="sidebar-title">菜品分类</div>
      <ul class="category-list">
        <li><router-link to="/cp/mycp1" exact-active-class="active">荤菜</router-link></li>
        <li><router-link to="/cp/mycp5" exact-active-class="active">半荤菜</router-link></li>
        <li><router-link to="/cp/mycp2" exact-active-class="active">素菜</router-link></li>
        <li><router-link to="/cp/mycp3" exact-active-class="active">主食甜点</router-link></li>
        <li><router-link to="/cp/mycp4" exact-active-class="active">精品小吃</router-link></li>
      </ul>
    </div>

    <!-- 菜品网格区域 -->
    <div class="dish-grid">
      <div class="dish-card" v-for="(dish, idx) in dishList" :key="idx">
        <el-image
          class="dish-img"
          :src="dish.thumb"
          :preview-src-list="[dish.preview]"
          fit="cover"
        >
          <div slot="error" class="error-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
        </el-image>
        <div class="dish-info">
          <span class="dish-name">{{ dish.name }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dishList: [
        { name: '白菜油豆腐', thumb: require('../../assets/cp/jbc/sc/01.jpg'), preview: require('../../assets/cp/jbc/sc/01-big.jpg') },
        { name: '豉油菜心', thumb: require('../../assets/cp/jbc/sc/02.jpg'), preview: require('../../assets/cp/jbc/sc/02-b.jpg') },
        { name: '豉油有机花菜', thumb: require('../../assets/cp/jbc/sc/03.jpg'), preview: require('../../assets/cp/jbc/sc/03-b.jpg') },
        { name: '醋溜土豆丝', thumb: require('../../assets/cp/jbc/sc/04.jpg'), preview: require('../../assets/cp/jbc/sc/04-b.jpg') },
        { name: '豆角杭茄', thumb: require('../../assets/cp/jbc/sc/06.jpg'), preview: require('../../assets/cp/jbc/sc/06-b.jpg') },
        { name: '粉丝娃娃菜', thumb: require('../../assets/cp/jbc/sc/08.jpg'), preview: require('../../assets/cp/jbc/sc/08-b.jpg') },
        { name: '腐竹木耳', thumb: require('../../assets/cp/jbc/sc/09.jpg'), preview: require('../../assets/cp/jbc/sc/09-b.jpg') },
        { name: '干煸豆角', thumb: require('../../assets/cp/jbc/sc/10.jpg'), preview: require('../../assets/cp/jbc/sc/10-b.jpg') },
        { name: '干煸莲条', thumb: require('../../assets/cp/jbc/sc/11.jpg'), preview: require('../../assets/cp/jbc/sc/11-b.jpg') },
        { name: '红烧茄子', thumb: require('../../assets/cp/jbc/sc/12.jpg'), preview: require('../../assets/cp/jbc/sc/12-b.jpg') },
        { name: '黄心菜烧豆腐', thumb: require('../../assets/cp/jbc/sc/13.jpg'), preview: require('../../assets/cp/jbc/sc/13-b.jpg') },
        { name: '椒盐白玉菇', thumb: require('../../assets/cp/jbc/sc/15.jpg'), preview: require('../../assets/cp/jbc/sc/15-b.jpg') },
        { name: '卤水千张', thumb: require('../../assets/cp/jbc/sc/16.jpg'), preview: require('../../assets/cp/jbc/sc/16-b.jpg') },
        { name: '麻婆豆腐', thumb: require('../../assets/cp/jbc/sc/17.jpg'), preview: require('../../assets/cp/jbc/sc/17-b.jpg') },
        { name: '麻油小白菜', thumb: require('../../assets/cp/jbc/sc/18.jpg'), preview: require('../../assets/cp/jbc/sc/18-b.jpg') },
        { name: '炒贡菜', thumb: require('../../assets/cp/jbc/sc/33.jpg'), preview: require('../../assets/cp/jbc/sc/33-b.jpg') },
        { name: '烧平菇', thumb: require('../../assets/cp/jbc/sc/20.jpg'), preview: require('../../assets/cp/jbc/sc/20-b.jpg') },
        { name: '蒜苗焖子', thumb: require('../../assets/cp/jbc/sc/22.jpg'), preview: require('../../assets/cp/jbc/sc/22-b.jpg') },
        { name: '蒜茸豆苗', thumb: require('../../assets/cp/jbc/sc/23.jpg'), preview: require('../../assets/cp/jbc/sc/23-b.jpg') },
        { name: '蒜蓉金针菇', thumb: require('../../assets/cp/jbc/sc/24.jpg'), preview: require('../../assets/cp/jbc/sc/24-b.jpg') },
        { name: '西芹腐竹', thumb: require('../../assets/cp/jbc/sc/25.jpg'), preview: require('../../assets/cp/jbc/sc/25-b.jpg') },
        { name: '香菇菜心', thumb: require('../../assets/cp/jbc/sc/26.jpg'), preview: require('../../assets/cp/jbc/sc/26-b.jpg') },
        { name: '香辣薯条', thumb: require('../../assets/cp/jbc/sc/28.jpg'), preview: require('../../assets/cp/jbc/sc/28-b.jpg') },
        { name: '小白菜炒油皮', thumb: require('../../assets/cp/jbc/sc/29.jpg'), preview: require('../../assets/cp/jbc/sc/29-b.jpg') },
        { name: '蟹黄豆腐', thumb: require('../../assets/cp/jbc/sc/30.jpg'), preview: require('../../assets/cp/jbc/sc/30-b.jpg') },
        { name: '鱼香茄子', thumb: require('../../assets/cp/jbc/sc/31.jpg'), preview: require('../../assets/cp/jbc/sc/31-b.jpg') },
        { name: '蒸时蔬', thumb: require('../../assets/cp/jbc/sc/32.jpg'), preview: require('../../assets/cp/jbc/sc/32-b.jpg') },
        { name: '松仁玉米粒', thumb: require('../../assets/cp/jbc/sc/34.jpg'), preview: require('../../assets/cp/jbc/sc/34-b.jpg') },
      ]
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.dish-showcase {
  max-width: 80%;
  margin: 30px auto;
  padding: 0 20px;
  display: flex;
  gap: 30px;
}

/* 侧边菜单 */
.sidebar {
  width: 220px;
  flex-shrink: 0;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  height: fit-content;
}
.sidebar-title {
  background: linear-gradient(135deg, #f97316, #facc15);
  color: #fff;
  font-size: 20px;
  font-weight: 600;
  text-align: center;
  padding: 16px 0;
  letter-spacing: 2px;
}
.category-list {
  list-style: none;
  padding: 12px 0;
}
.category-list li {
  margin: 0;
}
.category-list a {
  display: block;
  padding: 12px 24px;
  text-decoration: none;
  font-size: 16px;
  font-weight: 500;
  color: #4a5568;
  transition: all 0.2s;
  border-left: 3px solid transparent;
}
.category-list a:hover {
  background: #fef3e2;
  color: #f97316;
  border-left-color: #f97316;
  padding-left: 28px;
}
.category-list a.active {
  background: #fef3e2;
  color: #f97316;
  border-left-color: #f97316;
  font-weight: 600;
}

/* 菜品网格 */
.dish-grid {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(230px, 1fr));
  gap: 24px;
}
.dish-card {
  background: #fff;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 12px 24px -10px rgba(0, 0, 0, 0.08);
  transition: transform 0.25s, box-shadow 0.25s;
}
.dish-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 20px 28px -12px rgba(0, 0, 0, 0.15);
}
.dish-card:hover .dish-info {
  background: #b03e45;
}
.dish-card:hover .dish-info .dish-name {
  color:#fff;
}
.dish-img {
  width: 100%;
  height: 200px;
  display: block;
  background: #f0f0f0;
}
.dish-img /deep/ img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.4s;
}
.dish-card:hover .dish-img /deep/ img {
  transform: scale(1.03);
}
.dish-info {
  padding: 14px 16px 18px;
  text-align: center;
  background: #fff;
}
.dish-name {
  font-size: 18px;
  font-weight: 600;
  color: #2d3748;
  letter-spacing: 1px;
}
.error-slot {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  color: #cbd5e0;
}

</style>